// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__3SPFy","filesListContainer":"PosDisputesFiles_filesListContainer__TEccR","filesButton":"PosDisputesFiles_filesButton__trM5a"};